import styled, { css } from 'styled-components';
import { B as Box } from '../Box/Box-CRqR6LEm.js';
import { g as gapMixin, m as mobileGapMixin } from '../theme/style-mixins/gap/index-CO-zSMJ0.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

/* eslint-disable import/prefer-default-export */
const GridBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1du5djg-0"
})(["display:", ";border-radius:unset;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  $inline
}) => $inline ? 'inline-grid' : 'grid', ({
  $columns
}) => css(["grid-template-columns:", ";"], $columns), ({
  $rows
}) => css(["grid-template-rows:", ";"], $rows), ({
  $areas
}) => css(["grid-template-areas:", ";"], $areas), ({
  $alignContent
}) => css(["align-content:", ";"], $alignContent), ({
  $justifyContent
}) => css(["justify-content:", ";"], $justifyContent), ({
  $placeContent
}) => css(["place-content:", ";"], $placeContent), ({
  $alignItems
}) => css(["align-items:", ";"], $alignItems), ({
  $justifyItems
}) => css(["justify-items:", ";"], $justifyItems), ({
  $placeItems
}) => css(["place-items:", ";"], $placeItems), ({
  $autoColumns
}) => css(["grid-auto-columns:", ";"], $autoColumns), ({
  $autoRows
}) => css(["grid-auto-rows:", ";"], $autoRows), ({
  $autoFlow
}) => css(["grid-auto-flow:", ";"], $autoFlow), gapMixin, isMobile(css(["", ""], mobileGapMixin)));

export { GridBox as G };
//# sourceMappingURL=Grid.styles-un2pb9nZ.js.map
